module.exports = __webpack_public_path__ + "img/preview.1590a75d.svg";